import Interface from "../../../../interfaces/Interfaceable.js";

const ServiceDashboardInterface = new Interface("SocketListener", [
	"connect",
	"latest_essay_review_eta_updated",
]);

export default ServiceDashboardInterface;
